import { Component, HostListener, OnInit } from "@angular/core";
import { AppInitializerService, RefreshTokenService } from "@jwt";
import { LocalizationService } from "./core/services/localization.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

    constructor(
        private appInitializerService: AppInitializerService,
        private localizationService: LocalizationService,
        private refreshTokenService: RefreshTokenService) {
    }

    ngOnInit(): void {
        this.localizationService.setLocalization(this.appInitializerService.locale);
    }

    @HostListener("window:unload", ["$event"])
    unloadHandler() {
        // Invalidate current tab as active RefreshToken timer
        this.refreshTokenService.invalidateCurrentTabId();
    }

    @HostListener("window:beforeunload", ["$event"])
    beforeUnloadHander() {
        // ...
    }
}
